// 导入封装的方法
import {
  post
} from '../http'

const Collection = {
  list (params) {
    return post('/linkagehistoricalcollect/list', params)
  },
  info (params) {
    return post('/linkagehistoricalcollect/info/' + params)
  },
  add (params) {
    return post('/linkagehistoricalcollect/externalAdd', params)
  },
  tree (params) {
    return post('/linkagestructure/tree', params)
  },
  sendShortCode (params) {
    return post('/smsSend/sendShortCode', params)
  },
  newSendShortCode (params) {
    return post('/smsSend/newSendShortCode', params)
  },
  historicalList (params) {
    return post('/notice/historicalList', params)
  },
  linkageClueListByPhone (params) {
    return post('/linkage/clue/proposal/linkageClueListByPhone', params)
  },
  
  
}
export default Collection
